import { Box, Grid2 as Grid } from '@mui/material';
import React from 'react';
import supportIcon from '../../assets/icons/supportIcon.svg';
import abbottLogoBlueBlack from '../../assets/icons/abbottLogoBlueBlack.svg';
import { controlPadData } from '../../shared/shared.constants';
import { ControlPad } from '../../shared/components/controlPad';
import { TileGroup } from './tileGroup';
import { BoxStyled } from '../estimatingRequirements/faisyEquation/style';

export const Contact = () => {
  return (
    <>
      <BoxStyled sx={{ paddingBottom: '0px' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            gap: '1.875rem',
            marginBottom: '1.875rem',
            marginTop: '3.125rem'
          }}
        >
          <Box
            sx={{
              width: '110px',
              height: '110px',
              borderRadius: '100px',
              backgroundColor: '#fff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img src={supportIcon} alt="summaryIcon" />
          </Box>
          <Box
            sx={{
              width: '200px',
              height: 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img src={abbottLogoBlueBlack} alt="abbottLogoBlueBlack" />
          </Box>
        </Box>
        <TileGroup />
      </BoxStyled>
      <Grid container spacing={2}>
        {controlPadData.map((item) => (
          <ControlPad
            key={item.altVal}
            imgSrc={item.imgSrc}
            altVal={item.altVal}
            toLink={item.toLink}
            showIcon={item.showIcon}
          />
        ))}
      </Grid>
    </>
  );
};
